import { useQuery } from '@tanstack/react-query';
import { educationService } from '../services/education.service';
import type { Education } from '../types/education.types';

interface UseEducationsParams {
  candidateId: string;
}

interface UseEducationsResult {
  educations: Education[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export function useEducations({ candidateId }: UseEducationsParams): UseEducationsResult {
  const query = useQuery({
    queryKey: ['educations', candidateId],
    queryFn: () => educationService.list(candidateId),
    enabled: !!candidateId,
  });

  return {
    educations: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
